import GratuityButtons from './GratuityButtons';

export default GratuityButtons;
